












































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';

import Button, {
    ButtonSize,
    IconEnum,
} from '@/modules/shared/components/button.component.vue';
import CloudDocument from '@/modules/cloud/views/document.view.vue';

import Constants from '@/constants/constants.ts';

import textDecorate from '@/modules/shared/directives/text-decorate.directive.ts';

@Component({
    components: {
        Button,
        CloudDocument,
    },
    computed: {
        ...mapGetters({
            documents: 'getDocuments',
            studies: 'getStudies',
            hasMoreStudies: 'getHasMoreStudies',
        }),
    },
    directives: {
        textDecorate,
    },
})
export default class EcoCloud extends Vue {

    private buttonSize = ButtonSize;
    private iconEnum = IconEnum;
    private studiesLoad = false;

    public literals = {
        title: 'ECO Cloud',
        subtitle: 'Tus archivos siempre contigo',
        reportSection: 'Mis informes',
        suggestedSection: 'Documentos sugeridos para ti',
    };


    private created() {
        this.fetchDocuments();
        this.fetchStudies();
    }

    private loadAllStudies() {
        this.fetchStudies({});
    }

    private fetchStudies(params: any = { limit: Constants.limitMyStudies }) {
        this.$store.dispatch('fetchStudies', params);
    }

    private fetchDocuments() {
        this.$store.dispatch('fetchDocuments');
    }

}
